import { EnumGameMechanicCategory } from "src/@constants";
export const DragDropTextToImageGameData = {
  title: '',
  description: '',
  category: EnumGameMechanicCategory.drag_drop_text_to_image,
  points: 100,
  content: {
    annotations: [],
    filePath: null
  }
}
